import { chain, has, pick, some } from 'lodash';

export const getNewFormArrayItems = (array: any[]) => {
    return chain(array)
        .filter(obj => !has(obj, 'id'))
        .map(obj => {
            if (obj.type !== 'plainemail') {
                return pick(obj, ['type', 'data.id']);
            }
            return { ...obj };
        })
        .value();
};

export const getRemovedFormArrayItems = (
    formArray: any[],
    originalArray: any[],
) => {
    return chain(originalArray)
        .filter(
            itemTwo => !some(formArray, itemOne => itemOne.id === itemTwo.id),
        )
        .map(item => pick(item, ['id']))
        .value();
};
